export const sortedNamesOData: Record<string, string> = {
    ascend: 'asc',
    descend: 'desc',
};
